import "reflect-metadata";
import "./styles/main.scss";
import { createApp } from "@/core/create-app";
import AppEntrypoint from "@/modules/shared/components/AppEntrypoint.vue";
import { SharedModule } from "@/modules/shared/shared.module";
import { AuthModule } from "@/modules/auth/auth.module";
import { UsersModule } from "@/modules/users/users.module";
import { ApplicationsModule } from "@/modules/applications/applications.module";
import { TenantsModule } from "@/modules/tenants/tenants.module";
import { IdentityProvidersModule } from "@/modules/identity-providers/identity-providers.module";

const app = createApp(
  [SharedModule, AuthModule, UsersModule, ApplicationsModule, TenantsModule, IdentityProvidersModule],
  AppEntrypoint
);

app.then((vue) => vue.$mount("#app"));
